import { atom } from 'jotai'

/**
 * `off`: the mocks are not requested. `active`: the worker started. `failed`: the flag is on but
 * the worker did not start (timeout, refused registration): the badge says so instead of letting
 * a reviewer believe the page shows backend data.
 */
export type DevMocksStatus = 'off' | 'active' | 'failed'

export const devMocksStatusAtom = atom<DevMocksStatus>('off')
